import { QueryStatus } from '@reduxjs/toolkit/query';
import { globalLoadingEnabledSelector, globalLoadingIsLoadingSelector } from '../global-loading-slice';
import { hereMapsApi } from '@/app/services/hereMaps';
import { microsoftApi } from '@/app/services/microsoft';
import { solutionApi } from '@/app/services/solution';
import { useAppSelector } from '@/app/hooks';

const endpointsToExclude = new Set(['getAddresses', 'getCustomers']);

const useGlobalIsLoading = (): boolean => {
  const globalLoadingEnabled = useAppSelector(globalLoadingEnabledSelector);
  const isLoading = useAppSelector(globalLoadingIsLoadingSelector);

  const isPending = useAppSelector((state) => {
    const checkPending = (api: typeof solutionApi | typeof microsoftApi | typeof hereMapsApi): boolean =>
      Object.values(state[api.reducerPath].queries)
        .filter((query) => {
          return query?.endpointName !== undefined && !endpointsToExclude.has(query.endpointName);
        })
        .some((query) => {
          if (!query) {
            return false;
          }

          return query.status === QueryStatus.pending;
        }) ||
      Object.values(state[api.reducerPath].mutations)
        .filter((mutation) => {
          return mutation?.endpointName !== undefined && !endpointsToExclude.has(mutation.endpointName);
        })
        .some((mutation) => {
          if (!mutation) {
            return false;
          }

          return mutation.status === QueryStatus.pending;
        });

    return checkPending(solutionApi) || checkPending(microsoftApi) || checkPending(hereMapsApi);
  });

  return globalLoadingEnabled && (isPending || isLoading);
};

export default useGlobalIsLoading;
